enum ColumnType {
  CHECKBOX = 'checkbox',
  CHEVRON= 'chevron',
  DEFAULT = 'default',
  DYNAMIC = 'dynamic',
  SUPERSCRIPTION = 'superscription',
  SUPERSCRIPTION_BAR = 'superscription_bar'
}

export default ColumnType;
